import React from 'react'
import { Table } from 'react-bootstrap'
import AuditLog from './audit_log'

const AuditLogs = (props) => {
  const data = props.data.map((obj, i) => (
    <tr key={i}>
      <td style={{ border: '0' }}>
        <AuditLog processMetadata={props.processMetadata} obj={obj} />
      </td>
    </tr>
  ))
  const visibilityClass = props.isShown ? 'element-visible animated fadeIn' : 'element-hidden animated fadeOut'

  return (
    <Table striped bordered hover style={{ margin: '0', border: '0' }} className={visibilityClass}>
      <tbody>{data}</tbody>
    </Table>
  )
}

export default AuditLogs
